// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1326":"1848026e88460c3e","2968":"73fd0759bd3a83dd","4775":"41eb359465b8e790","5588":"fe77c9ae44fbd22a","6843":"69f20d32b8ca08fb","7840":"900b9eb5e11db2fc","8480":"277ca41bf1c5fd51","9045":"f6181706eba99f62","9674":"6cb7260d87ff2f56"}[chunkId] + ".js";
};